import { GET_SERVICECITY, GET_SERVICEREGION, GET_SUBVENDORREGION } from "resources/actionTypes";

const initialStateCity = {
  userServiceCity: [],
  loading: false,
  error: null,
};

const initialStateRegion = {
  userServiceRegion: [],
  loading: false,
  error: null,
};

// const initialStateAddRegion = {
//   userAddServiceRegion: [],
//   loading: false,
//   error: null,
// }

const initialStateSubVendorRegion = {
  userSubVendorRegion: [],
  loading: false,
  error: null,
};

// const initialStateAddSubVendorRegion = {
//   userServiceAddSubVednorRegion: [],
//   loading: false,
//   error: null,
// };

export function userServiceCity(state = initialStateCity, action){
  switch(action.type){
    case GET_SERVICECITY.GET_SERVICECITY_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SERVICECITY.GET_SERVICECITY_SUCCESS:
      return{
        ...state,
        loading: false,
        userServiceCity: action.userServiceCity
      };
    case GET_SERVICECITY.GET_SERVICECITY_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

export function userServiceRegion(state = initialStateRegion, action){
  switch(action.type){
    case GET_SERVICEREGION.GET_SERVICEREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SERVICEREGION.GET_SERVICEREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userServiceRegion: action.userServiceRegion
      };
    case GET_SERVICEREGION.GET_SERVICEREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

// export function userAddServiceRegion(state = initialStateAddRegion, action){
//   switch(action.type){
//     case GET_ADDSERVICEREGION_REQUESTED:
//       return{
//         ...state,
//         loading:true
//       };
//     case GET_ADDSERVICEREGION_SUCCESS:
//       return{
//         ...state,
//         loading: false,
//         userAddServiceRegion: action.userAddServiceRegion
//       };
//     case GET_ADDSERVICEREGION_FAILED:
//       return{
//         ...state,
//         loading:false,
//         error: action.message
//       };
//       default:
//         return state;
//   }
// }

export function userSubVendorRegion(state = initialStateSubVendorRegion, action){
  switch(action.type){
    case GET_SUBVENDORREGION.GET_SUBVENDORREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SUBVENDORREGION.GET_SUBVENDORREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userSubVendorRegion: action.userSubVendorRegion
      };
    case GET_SUBVENDORREGION.GET_SUBVENDORREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

// export function userServiceAddSubVendorRegion(state = initialStateAddSubVendorRegion, action){
//   switch(action.type){
//     case GET_ADDSUBVENDORREGION_REQUESTED:
//       return{
//         ...state,
//         loading:true
//       };
//     case GET_ADDSUBVENDORREGION_SUCCESS:
//       return{
//         ...state,
//         loading: false,
//         userAddSubVendorRegion: action.userAddSubVendorRegion
//       };
//     case GET_ADDSUBVENDORREGION_FAILED:
//       return{
//         ...state,
//         loading:false,
//         error: action.message
//       };
//       default:
//         return state;
//   }
// }